export const AUTH_SIGNATURE_FAILED_MESSAGE =
  "Error requesting authentication. Make sure your wallet is unlocked and connected, then try again. If it still fails, log out of 6529 and log back in.";
